export default {
  "SettingsHeader": "_SettingsHeader_1lwgy_1",
  "SettingsTabs": "_SettingsTabs_1lwgy_9"
};import "ni:sha-256;ef1daBB2gh5FrcOFnsEJSd72kPlR97K5-sLDqp_Fgio";